// extracted by css-extract-rspack-plugin
export default {"iconProfession":"bbvbPI","top3Operators":"AWVeL1","operators":"MGmO6n","operator":"n_4OON","portrait":"cd4xCJ","profession":"eLJRBM","label":"ahywhH","icon":"vS42XL"};